<div class="topbar">
  <div class="row row--align-center">
    <button class="sidenav-button full-height" type="button" (click)="showMobileNavigation.emit()">
      <img [src]="icon" alt="" class="icon" />
    </button>
    <a routerLink="/dashboard">
      @if ((loadingCustomizations$ | async) === false) {
        <div class="logo-container">
          <img class="logo" [src]="topBarLogoPath" title="Top Bar Logo" alt="Top Bar Logo"/>
        </div>
      }
    </a>
  </div>
  <div class="row row--align-center margin-right--lg">
    @if (showMediprocityMailbox$ | async) {
      <div class="widget">
        @if (unreadMessages > 0) {
          <div class="{{unreadMessages > 9 ? 'badge badge__multiple' : 'badge badge__single'}}">
          {{unreadMessages > 100 ? '100+' : unreadMessages }}</div>
        }
        <span class="dx-icon-message icon" (click)="openMediprocity()"></span>
      </div>
    }
    @if (theme === 'dark') {
      <i class="fa fa-sun-o theme" (click)="toggleTheme('light')"></i>
    }
    @if (theme === 'light') {
      <i class="fa fa-moon-o theme" (click)="toggleTheme('dark')"></i>
    }
    <app-dropdown [alignLeft]="false">
      <ng-container header>
        <div class="profile-dropdown">
          @if ((user$ | async); as user) {
            <span id="dropdown.profile-name" data-cy="dropdown-profile-name" class="profile-dropdown__name"
              >
              {{user.firstName}} {{user.lastName}}
            </span>
          }
          <i class="material-icons">expand_more</i>
        </div>
      </ng-container>
      <ng-container body>
        <div class="dropdown-body">
          <a target="_blank" [href]="iamPortalLink" class="dropdown-body__item">
            <i class="material-icons">supervised_user_circle</i>
            <span>Open IAM Portal</span>
          </a>
          <div class="dropdown-body__item" (click)="changePassword()">
            <i class="material-icons">lock_reset</i>
            <span>Change Password</span>
          </div>
          @if (advancedLicense) {
            <div class="dropdown-body__item" (click)="linkMediprocity()">
              <i class="material-icons">forum</i>
              <span>Mediprocity Link</span>
            </div>
          }
          <div class="dropdown-body__item" (click)="userGuide()">
            <i class="material-icons">article</i>
            <span>User Guide</span>
          </div>
          <a class="dropdown-body__item" href="https://help.frameworkltc.com/support/home" target="_blank">
            <i class="material-icons">support_agent</i>
            <span>SoftWriters Support</span>
          </a>
          <div id="dropdown.signout-button" data-cy="dropdown-signout-button" class="dropdown-body__item"
            (click)="logout()">
            <i class="material-icons">logout</i>
            <span>Sign Out</span>
          </div>
        </div>
      </ng-container>
    </app-dropdown>
  </div>
</div>
<app-modal #passwordModal header="Change password" [showModal]="showChangePassword" (modalClose)="modalClosed()">
  <app-change-password [modal]="passwordModal"></app-change-password>
</app-modal>
<app-modal #mediprocityLinkModal header="Mediprocity Link" [showModal]="showMediprocityLink"
  (modalClose)="modalClosed()">
  <app-mediprocity-link [modal]="mediprocityLinkModal"></app-mediprocity-link>
</app-modal>
<app-modal #mediprocityWidgetModal header="Mediprocity" [showModal]="showMediprocityWidget" size="body_lg"
  (modalClose)="modalClosed()">
  <app-mediprocity-widget [modal]="mediprocityWidgetModal" [triggerReload]="triggerWidgetReload">
  </app-mediprocity-widget>
</app-modal>
